module.exports = __webpack_public_path__ + "media/images/logo-390671cbf923fabf207115d4ae2692a7.svg";